import React, { useState } from 'react';

//components
import EditSubmitButtonDetails from './EditSubmitButtonDetails';
import SubmitButtonDetails from './SubmitButtonDetails';

//interfaces
import { ISubmitFormButton } from '../../../../interfaces/IFormBuilderButtons';
import { IFormButtonElement } from '../../../../interfaces/IFormElement';



const FormButtonElement = ({submitButtonText, setSubmitButtonText, validationErrors, formButtonType}: ISubmitFormButton ) => {
    const [isEditMode, setIsEditMode]=useState<boolean>(false);
    
    return (
        isEditMode
            ?   <EditSubmitButtonDetails 
                    type={formButtonType as IFormButtonElement}
                    placeholderText={"Enter your text here"}
                    submitButtonText={submitButtonText} 
                    setSubmitButtonText={setSubmitButtonText}
                    onContinueClick={()=>setIsEditMode(false)}
                    validationErrors={validationErrors}
                />
                    
            :   <SubmitButtonDetails 
                    type={formButtonType as IFormButtonElement}
                    submitButtonText={submitButtonText} 
                    onEditClick={()=>setIsEditMode(true)}
                    validationErrors={validationErrors}
                />
    );
};

export default FormButtonElement